module.exports = __webpack_public_path__ + "assets/apache-wicket.86cb671e.svg";